// extracted by mini-css-extract-plugin
export default {"botonResultado":"ResultadoListaPartidos_botonResultado__Y3JOL"};